import React from 'react'
import SimpleReactLightbox from 'simple-react-lightbox'
import 'rc-slider/assets/index.css'

// eslint-disable-next-line react/prop-types
export const wrapRootElement = ({ element }) => (
  <SimpleReactLightbox>{element}</SimpleReactLightbox>
)